import { Action } from 'redux'
import { IInvoice } from '../../models/Invoice'
import { InvoiceActions } from '../../reducers/invoice/actionNames'

const invoiceAccepted = (
  invoice: IInvoice,
  id: string,
  newInvoice = false,
): IInvoiceAccepted => ({
  id,
  invoice,
  newInvoice,
  type: InvoiceActions.Accepted,
})

export interface IInvoiceAccepted extends Action<InvoiceActions.Accepted> {
  id: string
  invoice: IInvoice
  newInvoice?: boolean
}

export default invoiceAccepted
